module.exports = __webpack_public_path__ + "img/banks-tool.69515ff7.png";